import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
  *, *::before, *::after { box-sizing: border-box; }

  html, body, #root { height: 100%; margin: 0; padding: 0; }

  html {
    scroll-behavior: smooth;
    text-size-adjust: 100%;
    /* Флажки, радиокнопки, календарь и полосы прокрутки — в цвет темы ОСНОВЫ,
       а не системы: при тёмной Windows и светлой теме они были тёмными. */
    color-scheme: ${({ theme }) => (theme.name === 'dark' ? 'dark' : 'light')};
  }

  body {
    font-family: ${({ theme }) => theme.font.family};
    font-feature-settings: 'cv11', 'ss01', 'ss03', 'ss07', 'ss08';
    background: ${({ theme }) => theme.colors.background};
    color: ${({ theme }) => theme.colors.text.primary};
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    line-height: 1.5;
    transition: background ${({ theme }) => theme.motion.base} ${({ theme }) => theme.motion.easeOut},
                color ${({ theme }) => theme.motion.base} ${({ theme }) => theme.motion.easeOut};
  }

  h1, h2, h3, h4, h5 {
    letter-spacing: -0.01em;
    font-weight: 600;
  }

  a {
    color: ${({ theme }) => theme.colors.primary};
    text-decoration: none;
    transition: color ${({ theme }) => theme.motion.fast} ${({ theme }) => theme.motion.easeOut};
  }
  a:hover { color: ${({ theme }) => theme.colors.primaryHover}; }

  code, pre, .mono { font-family: ${({ theme }) => theme.font.mono}; }

  button { font-family: inherit; }

  *:focus { outline: none; }
  *:focus-visible {
    outline: none;
    box-shadow: ${({ theme }) => theme.shadow.focus};
    border-radius: ${({ theme }) => theme.radius.xs};
  }

  ::selection {
    background: ${({ theme }) => theme.colors.primary};
    color: #FFFFFF;
  }

  /* Полосы прокрутки — свои и единые на всех страницах, вертикальные и
     горизонтальные: ползунок терракотовый, цвета бренда, на нейтральной
     дорожке, которая видна всегда. Раньше ползунок был цвета рамки на
     прозрачной дорожке, и горизонтальную прокрутку широких таблиц не
     замечали; потом был красный неон (PR #1397) и серый (PR #1403). Chromium и
     Safari рисуют по ::-webkit-scrollbar (так полосы не прячутся и в macOS);
     Firefox их не знает — ему цвета через scrollbar-color. В Chromium
     scrollbar-color и scrollbar-width у элемента отключают
     ::-webkit-scrollbar, поэтому они — только для Firefox, и в компонентах их
     не ставим. */
  ::-webkit-scrollbar { width: 14px; height: 14px; }
  ::-webkit-scrollbar-track {
    background: ${({ theme }) => theme.colors.scrollbar.track};
    border-radius: ${({ theme }) => theme.radius.pill};
  }
  ::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.colors.scrollbar.thumb};
    border: 2px solid transparent;
    border-radius: ${({ theme }) => theme.radius.pill};
    background-clip: padding-box;
  }
  ::-webkit-scrollbar-thumb:hover,
  ::-webkit-scrollbar-thumb:active {
    background: ${({ theme }) => theme.colors.scrollbar.thumbHover};
    background-clip: padding-box;
  }
  ::-webkit-scrollbar-corner { background: transparent; }

  @supports not selector(::-webkit-scrollbar) {
    * {
      scrollbar-width: auto;
      scrollbar-color: ${({ theme }) => theme.colors.scrollbar.thumb} ${({ theme }) => theme.colors.scrollbar.track};
    }
  }

  @media (prefers-reduced-motion: reduce) {
    *, *::before, *::after {
      animation-duration: 0.01ms !important;
      animation-iteration-count: 1 !important;
      transition-duration: 0.01ms !important;
      scroll-behavior: auto !important;
    }
  }
`;
